var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"auth-layout"},[_c('div',{staticClass:"auth-form"},[_c('router-view')],1),_vm._m(0)])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"auth-gif"},[_c('img',{attrs:{"src":require("./../assets/img/auth.gif"),"alt":"auth"}})])
}]

export { render, staticRenderFns }